import { Component } from '@angular/core';
import { PlotService } from '../../../services/plot.service';

@Component({
  selector: 'ebw-plot-map-control',
  templateUrl: './plot-map-control.component.html',
  styleUrls: ['./plot-map-control.component.scss']
})
export class PlotMapControlComponent {
  constructor(private _plotService: PlotService) {}

  openPlot() {
    if (!this._plotService.isPlotOpen()) {
      this._plotService.openPlot();
    }
  }
}
